/**
 * Speakers confirmados para el CEC 2026
 *
 * Para agregar un speaker:
 * 1. Coloca la foto en /public/assets/images/speakers/
 * 2. Agrega una entrada en el array
 */

const speakersData = [
  {
    name: "Alina Nassar",
    position: "Socia",
    institution: "Nassar Abogados",
    photo: "/assets/images/speakers/alina_nassar.jpg",
    linkedinUrl: "https://www.linkedin.com/in/alina-nassar-73730613",
    keynote: false,
  },
  {
    name: "Charity Weeden",
    position: "Former Associate Administrator for Technology, Policy, and Strategy",
    institution: "National Aeronautics and Space Administration (NASA)",
    photo: "/assets/images/speakers/charity_weeden.png",
    linkedinUrl: "https://www.linkedin.com/in/caweeden/",
    keynote: true,
  },
  {
    name: "Dr. Rajasekhar Meka",
    position: "Earth Observation & Space Science Expert",
    institution: "ISRO Satish Dhawan Space Centre SHAR",
    photo: "/assets/images/speakers/rajasekhar_meka.png",
    linkedinUrl: "https://www.linkedin.com/in/dr-rajasekhar-meka-b5802518/",
    keynote: false,
  },
  {
    name: "Prof. Raja (Puragra) Guhathakurta",
    position: "Department Chair",
    institution: "University of California Santa Cruz",
    photo: "/assets/images/speakers/raja_puragra_guhathakurta.png",
    linkedinUrl: "https://www.linkedin.com/in/raja-puragra-guhathakurta-12067b8b/",
    keynote: false,
  },
  {
    name: "Neal Lii",
    position: "Head Domain, Space Robotic Assistance",
    institution: "The German Aerospace Center (DLR)",
    photo: "/assets/images/speakers/neal_lii.png",
    linkedinUrl: "https://www.linkedin.com/in/neal-lii-64982aba/",
    keynote: false,
  },
  {
    name: "Esteban Carrillo",
    position: "Executive Director",
    institution: "Costa Rica Aerospace Cluster",
    photo: "/assets/images/speakers/esteban_carrillo.png",
    linkedinUrl: "https://www.linkedin.com/in/esteban-carrillo-71212a349/",
    keynote: false,
  },
  {
    name: "Laura Delgado",
    position: "Senior Fellow, Jack D. Gordon Institute for Public Policy",
    institution: "Florida International University (FIU)",
    photo: "/assets/images/speakers/laura_delgado.png",
    linkedinUrl: "https://www.linkedin.com/in/laura-delgado-lopez/",
    keynote: true,
  },
  {
    name: "Enrique Pacheco",
    position: "Senior Adviser for Latin America",
    institution: "Nara Space",
    photo: "/assets/images/speakers/enrique_pacheco.jpg",
    linkedinUrl: "https://www.linkedin.com/in/enrique-pacheco-a9781828/",
    keynote: false,
  },
  {
    name: "Dr. Jason Reimuller",
    position: "Executive Director",
    institution: "Institute for Astronautical Sciences Science (IIAS)",
    photo: "/assets/images/speakers/jason_reimuller.jpg",
    linkedinUrl: "https://www.linkedin.com/in/jason-reimuller-8677b04/",
    keynote: true,
  },
  {
    name: "Dr. Luis Zea",
    position: "Chief Scientist",
    institution: "Starlab",
    photo: "/assets/images/speakers/luis_zea.png",
    linkedinUrl: "https://www.linkedin.com/in/spaceluiszea/",
    keynote: true,
  },
  {
    name: "Daichi Hirano",
    position: "Senior Aerospace Development Engineer",
    institution: "Japan Aerospace Exploration Agency (JAXA)",
    photo: "/assets/images/speakers/daichi_hirano.jpg",
    linkedinUrl: "https://www.linkedin.com/in/daichi-hirano-138568332/",
    keynote: true,
  },
  {
    name: "Yajaira Sierra",
    position: "Crew Training Systems Lead",
    institution: "Blue Origin",
    photo: "/assets/images/speakers/yajaira_sierra.jpg",
    linkedinUrl: "https://www.linkedin.com/in/yajaira-sierra-sastre/",
    keynote: true,
  },
  {
    name: "Mizanul Chowdhury",
    position: "Founder and CEO",
    institution: "STEMX-365",
    photo: "/assets/images/speakers/mizanul_chowdhury.jpg",
    linkedinUrl: "https://www.linkedin.com/in/mizanul-chowdhury-54299712/",
    keynote: false,
  },
  {
    name: "Yaítza Luna-Cruz",
    position: "Program Executive and Program Manager",
    institution: "National Aeronautics and Space Administration (NASA)",
    photo: "/assets/images/speakers/yaitza_luna.jpg",
    linkedinUrl: "https://www.linkedin.com/in/ya%C3%ADtza-luna-cruz-ph-d-47b2a596/",
    keynote: false,
  },
  {
    name: "Rodrigo Leonardi",
    position: "Director",
    institution: "Agência Espacial Brasileira (AEB)",
    photo: "/assets/images/speakers/rodrigo_leonardi.jpg",
    linkedinUrl: "https://www.linkedin.com/in/rodrigo-leonardi-90a2a190/",
    keynote: false,
  },
  {
    name: "Bruce Nicayenzi",
    position: "Sloan Fellow",
    institution: "MIT Sloan School of Management",
    photo: "/assets/images/speakers/bruce_nicayenzi.jpg",
    linkedinUrl: "https://www.linkedin.com/in/bnic1/",
    keynote: false,
  },
  {
    name: "Jonathan Barlow",
    position: "Senior Aerospace Research Engineer",
    institution: "ARKYSIS",
    photo: "/assets/images/speakers/jonathan_barlow.jpg",
    linkedinUrl: "https://www.linkedin.com/in/jonathan-barlow-1865229/",
    keynote: false,
  },
  {
    name: "Celeste Saade",
    position: "Head of Research",
    institution: "Key Institute",
    photo: "/assets/images/speakers/celeste_saade.jpg",
    linkedinUrl: "https://www.linkedin.com/in/celeste-saade/",
    keynote: false,
  },
  {
    name: "Dr. Javier Mejuto",
    position: "Decano de la Facultad de Ciencias Espaciales",
    institution: "Universidad Nacional Autónoma de Honduras (UNAH)",
    photo: "/assets/images/speakers/javier_mejuto.png",
    linkedinUrl: "https://www.linkedin.com/in/javier-mejuto-44262426/",
    keynote: false,
  },
  {
    name: "Esteban Jiménez",
    position: "Cofounder and Senior Propulsion Engineer",
    institution: "VEL Space",
    photo: "/assets/images/speakers/esteban_jimenez.jpg",
    linkedinUrl: "https://www.linkedin.com/in/esteban-jimenez93/",
    keynote: false,
  },
  {
    name: "MSc. M.A. José Bagur",
    position: "Coordinador del Laboratorio Aeroespacial",
    institution: "Universidad del Valle de Guatemala (UVG)",
    photo: "/assets/images/speakers/jose_bagur.jpg",
    linkedinUrl: "https://www.linkedin.com/in/joseantoniobagur/",
    keynote: false,
  },
];

export default speakersData;